import BlueDotsBackground from '../../BlueDotsBackground';
import images from '../../content/mfpContent';
import people from '../../content/people';

export default function Articles() {
  return (
    <>
      <BlueDotsBackground />

      <section id="header" className="text-white px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <header className="text-left">
            <h1 className="text-4xl font-bold text-white">
              MFP Long-Term Success
            </h1>

            <div className="mt-4 flex items-center justify-start gap-4">
              <div className="text-sm text-gray-400">
                <p>06/10/2025</p>
                <p>Written by Josh Gingerich</p>
              </div>
              <img
                src={people[3].image}
                alt={people[3].name}
                className="w-10 h-10 rounded-full object-cover border-2 border-white/30 shadow-md"
              />
            </div>
          </header>
        </div>
      </section>

      {/* Article Section */}
      <section id="article" className="text-white px-6 py-4">
        <div className="flex items-center justify-center min-h-screen">
          <div className="mb-24 max-w-2xl px-4 text-left">
            <p className="text-sm text-gray-300">
              <span className="font-bold text-white">
                With the first wave of MFP-covered drugs approaching, all nine
                impacted manufacturers have opted for an outsourced stopgap
                solution that focuses on the most immediate requirements for MFP
                effectuation.
              </span>{' '}
              <br />
              <br />
              This unanimous move reflects the significant uncertainty in the
              current landscape and highlights a broader realization: the
              industry needs a flexible, purpose-built system to manage this
              complex new environment. Existing revenue management solutions
              ultimately lacked the adaptability needed to support this
              transition. However, for long-term success it is important to
              understand the foundational capabilities that a solution must be
              able to provide in order to ensure a robust, sustainable MFP
              process.
              <br />
              <br />
              <span className="font-bold text-white">
                Core Capabilities for MFP Effectuation
                <br />
                <br />
                <i className="fas fa-link mr-2 text-2xl"></i>
                Integration of MTF Script-Level Data
              </span>{' '}
              <br />
              <br />
              The claim-level detail (CLD) provided by the MTF is essential for
              accurate and effective validation. Any system processing MFP
              claims must support a comprehensive set of validations that
              leverage this granular data to safeguard revenue and ensure full
              visibility. Given this level of detail, solutions should also be
              prepared to validate against the broader universe of script-level
              data, including both Managed Care and Medicaid sources.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-calculator-simple mr-2 text-2xl"></i>
                Support for Variable Acquisition-Based Rebates
              </span>{' '}
              <br />
              <br />
              <img
                src={images[1]}
                alt={images[1]}
                className="w-30 h-20 mx-auto shadow-md"
              />
              <br />
              Not every drug is acquired at list price. Applying the Standard
              Default Refund Amount uniformly can result in overpayments. A
              robust solution must support claim effectuation at multiple
              acquisition-based pricing levels to align payouts accurately with
              what the manufacturer is liable for.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-file-circle-xmark mr-2 text-2xl"></i>
                Prevention of Duplicate Discounts Across Pricing Channels
              </span>{' '}
              <br />
              <br />
              While preventing 340B duplication is understandably a primary
              concern, it is not the only one. Acquisition prices under federal
              pricing or GPO contracts may also justify a lower refund than the
              default calculation of WAC minus MFP. A long-term solution must
              include mechanisms to validate all acquisition costs and ensure
              manufacturers are not inadvertently providing multiple discounts
              for the same drug.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-handshake mr-2 text-2xl"></i>
                Dispute Resolution Workflow
              </span>{' '}
              <br />
              <br />
              The ability to dispute questionable claims is essential for
              manufacturers to prevent revenue leakage. Whether dealing with
              incorrect information or 340B duplicates, the solution must enable
              a transparent and collaborative resolution process with pharmacies
              to address disputes in a timely and good-faith manner.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-arrows-rotate mr-2 text-2xl"></i>
                Claim Correction and Reprocessing
              </span>{' '}
              <br />
              <br />
              Errors are inevitable. When a claim is paid incorrectly, the
              solution must be able to generate appropriate credit offsets to
              make the manufacturer whole. These credits must be tracked at the
              pharmacy and NDC11 level to ensure accurate reconciliation and
              prevent cascading issues with future claims.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-syringe mr-2 text-2xl"></i>
                Medicare Part B
              </span>{' '}
              <br />
              <br />
              Until now, the Medicare Drug Price Negotiation Program (MFP) has
              only affected drugs reimbursed under Medicare Part D. However,
              beginning as early as 2028, Medicare Part B drugs, typically
              physician-administered medications, will also come under its
              scope. This shift introduces new operational complexities, as the
              distribution and billing pathways for Part B drugs differ
              significantly from those of retail-dispensed Part D drugs. As a
              result, MFP implementation strategies must evolve. Solutions will
              need to accommodate not only pharmacy-processed claims but also
              claims originating from physician offices, outpatient clinics, and
              other provider settings.
              <br />
              <br />
              <span className="font-bold text-white">
                Guaranteed Changes
              </span>{' '}
              <br />
              <br />
              The past few years have shown that the pharmaceutical landscape is
              subject to rapid and significant change. Even a system that meets
              today’s MFP processing requirements must be prepared to evolve.
              One area that is already generating attention is the proposed 340B
              Rebate Model, which may reshape how these discounts are handled in
              the near future, inevitably impacting the MFP process along the
              way. Flexibility is no longer a luxury, but a requirement.
              Solutions must be built not just for today’s compliance, but also
              for tomorrow’s. Organizations that invest in flexible, intelligent
              infrastructure will be best positioned to adapt quickly and avoid
              costly disruptions as new regulations and models emerge.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
